import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_BANK_ACCOUNT_LIST_BY_USER_API_ID =
  'INVESTMENT/FETCH_BANK_ACCOUNT_LIST_BY_USER_API';

// Takes the route's :userId and sends it as the user_id filter.
const apiCall = createApiCall(
  FETCH_BANK_ACCOUNT_LIST_BY_USER_API_ID,
  ({ userId, id, ...params }: { userId: string; [key: string]: any }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/bank-accounts`,
      params: { ...params, user_id: userId },
    }),
    method: 'GET',
  })
);

export default apiCall;
